import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable, Entity, ContentNode as TContentNode } from '@shapeable/types';
import { breakpoints, theme, ColorTokens } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ContentNode, useLang } from '@shapeable/ui';
import { PledgeButton } from './pledge-button';

const cls = classNames('pledge-status-indicator-cta');

// -------- Types -------->

// -------- Props -------->

export type PledgeStatusIndicatorCtaProps = Classable & HasChildren & { 
  entity?: Entity;
};

export const PledgeStatusIndicatorCtaDefaultProps: Omit<PledgeStatusIndicatorCtaProps, 'entity'> = {
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.UNIT(5)}
  `,
});

const MessageStyles = breakpoints({
  base: css`
    font-weight: 400;
    font-size: 1.5em;
    line-height: 1.3;
    font-family: ${theme.FONT('serif')};
    color: ${theme.COLOR('strong')}
  `,
});

const PledgeButtonStyles = breakpoints({
  base: css`
    max-width: 300px;
  `,
});

// -------- Components -------->

const My = {
  Container: styled.div<ContainerProps>`${ContainerStyles}`,
    Message: styled(ContentNode)`${MessageStyles}`,
    PledgeButton: styled(PledgeButton)`${PledgeButtonStyles}`,
};

export const PledgeStatusIndicatorCta: Shapeable.FC<PledgeStatusIndicatorCtaProps> = (props) => {
  const { className, children, entity } = props;

  const t = useLang();
  
  const ctaMessage: TContentNode = {
    text: 'We accept pledges to protect or restore kelp forests, increase awareness, assist conservation projects, or inspire the world. If you think you can help the kelp, let us know.'
  }
  return (
    <My.Container className={cls.name(className)}>
      <My.Message entity={ctaMessage}/>
      <My.PledgeButton href='https://forms.office.com/r/K38JkuWRa8' >{t('MAKE A PLEDGE')}</My.PledgeButton>
    {children}
    </My.Container>
  )
};

PledgeStatusIndicatorCta.cls = cls;